<template>
  <p class="text-h6 mb-4">{{ $t("component.notFoundModel.categoryTitle") }}</p>

  <v-select
    :model-value="selectedCategoryId"
    :label="$t('component.notFoundModel.categoryLabel')"
    :items="categories"
    item-title="name"
    item-value="id"
    variant="underlined"
    color="primary"
    @update:model-value="emit('update:selectedCategoryId', $event)"
  />

  <v-sheet
    v-for="bike in filteredBikes"
    :key="bike.id"
    class="d-flex align-center bg-background py-2"
    style="cursor: pointer"
    @click="emit('select-bike', bike.id)"
  >
    <v-img
      contain
      max-width="64"
      :src="util.bikeImageUrl(bike)"
      :v-image-fallback="util.transpPixel()"
    />
    <span class="ml-3">{{ bike.model }}</span>
  </v-sheet>

  <v-btn
    block
    color="primary"
    class="mt-6"
    :disabled="selectedCategoryId == null"
    @click="emit('continue')"
  >
    {{ $t("component.notFoundModel.notFoundButton") }}
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useUtils } from "@/composables/useUtils";
import type { Bike } from "@/types/api";

const props = defineProps<{
  categories: { id: number; name: string }[];
  bikes: Bike[];
  selectedCategoryId: number | null;
}>();

const emit = defineEmits<{
  "update:selectedCategoryId": [value: number | null];
  "select-bike": [bikeId: number];
  continue: [];
}>();

const util = useUtils();

const filteredBikes = computed(() =>
  props.bikes.filter((bike) => bike.bikeType?.id === props.selectedCategoryId)
);
</script>
